import { NavMarker } from 'react-rhumb';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ViewNotAvailable({
  endDate
}) {
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    type: "error",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "DOCUMENT_NOT_AVAILABLE"
    }), /*#__PURE__*/_jsx(FormattedReactMessage, {
      "data-test-id": "view-not-available-message",
      message: "view.notAvailable",
      options: {
        date: /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "medium-date",
          value: endDate
        })
      }
    })]
  });
}